export const RECEPTIONISTS_INVOICE_MENTION_DATA = {
  label: 'Receptionniste',
  required: false,
};
